import { request } from "../../services/Request";
import * as action from "../../utils/Actions";
import * as url from "../../utils/Url";

export function userLogin(loginData) {
    return (dispatch) =>
        dispatch({
            type: action.USER_LOGIN,
            payload: request(url.FORM_SERVICE).post(`/auth/login`, loginData)
        }).catch(response => { });
}

export function resetLoginData(){
    return (dispatch)=>
    dispatch({
      type: action.RESET_LOGIN_DATA
    });
}